import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import step1 from "@static/img/accountDetails/step1.png";
import step2 from "@static/img/accountDetails/step2.png";
import step3 from "@static/img/accountDetails/step3.png";
import "./css/PortInExplanation.scss";

interface IParams {
    alt: string;
    src: string;
    texts: [string, string, string];
    title: string;
}

export const AccountDetailsExplanation = (props: IParams) => {
    const {
        alt,
        src,
        texts: [step1Text, step2Text, step3Text],
        title,
    } = props;

    return (
        <Card>
            <CardContent>
                <Grid container justify="center" spacing={2}>
                    <img alt={alt} className="explanation-title__image" src={src} />
                    <Grid item xs={12}>
                        <Typography align="center" color="secondary" gutterBottom variant="body1">
                            {title}:
                        </Typography>
                    </Grid>
                </Grid>
                <Divider />
                <Grid alignItems="flex-start" className="explanation-steps" container spacing={2}>
                    <Grid className="explanation-steps__item" item md={4} xs={12}>
                        <img alt="step 1" src={step1} />
                        <Typography color="primary" variant="body1">
                            {step1Text}
                        </Typography>
                    </Grid>
                    <Grid className="explanation-steps__item" item md={4} xs={12}>
                        <img alt="step 2" src={step2} />
                        <Typography color="primary" variant="body1">
                            {step2Text}
                        </Typography>
                    </Grid>
                    <Grid className="explanation-steps__item" item md={4} xs={12}>
                        <img alt="step 3" src={step3} />
                        <Typography color="primary" variant="body1">
                            {step3Text}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};
